import { css } from '@emotion/react';
import { flex, themed } from '@spotnana/blocks/src/utils';

export const travel_summary_content = css`
  ${flex.init}
  ${flex.column}
`;

export const icon_color = themed(
  ({ palette }) => css`
    color: ${palette.icon.primary};
  `,
);
